module.exports = __webpack_public_path__ + "img/platinum_logo.3b3bfeab.webp";